// Tool errors are surfaced both as a `tool_status: error` event and as a
// `tool_result` whose content is the canonical `tool_error(...)` envelope
// the @tool decorator emits — a JSON object shaped
// `{"error": true, "message": "..."}` (see apps/core/errors.py).
export function extractToolErrorMessage(content: string): string | undefined {
  if (!content || typeof content !== "string") return undefined
  const trimmed = content.trim()
  if (!trimmed.startsWith("{")) return undefined
  try {
    const parsed = JSON.parse(trimmed)
    if (parsed && parsed.error === true && typeof parsed.message === "string") {
      return parsed.message
    }
  } catch {
    // Not JSON — not a tool_error envelope.
  }
  return undefined
}
